const ArrowLeft = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4472 9.47572H4.58871L6.7785 7.28593C7.01432 7.05011 7.01432 6.66269 6.7785 6.42687C6.54267 6.19104 6.15525 6.19104 5.91943 6.42687L2.68529 9.66101C2.6516 9.69469 2.63476 9.72838 2.60107 9.76207C2.60107 9.77892 2.58422 9.77892 2.58422 9.79576C2.56738 9.8126 2.55053 9.84629 2.55053 9.86314C2.55053 9.87998 2.53369 9.89683 2.53369 9.91367C2.53369 9.93052 2.51684 9.94736 2.51684 9.9642C2.51684 9.99789 2.5 10.0484 2.5 10.0821C2.5 10.1158 2.5 10.1663 2.51684 10.2C2.51684 10.2169 2.53369 10.2337 2.53369 10.2506C2.55053 10.2843 2.55053 10.3011 2.55053 10.3179C2.56738 10.3348 2.56738 10.3685 2.58422 10.3853C2.58422 10.4022 2.60107 10.4022 2.60107 10.419C2.61791 10.4527 2.6516 10.4864 2.68529 10.5201L5.91943 13.7542C6.03734 13.8721 6.18894 13.9395 6.35738 13.9395C6.52583 13.9395 6.67743 13.8721 6.79534 13.7542C7.03116 13.5184 7.03116 13.131 6.79534 12.8951L4.60556 10.7054H16.4641C16.801 10.7054 17.0705 10.4359 17.0705 10.099C17.0536 9.76207 16.7841 9.47572 16.4472 9.47572Z"
        fill="#000000"
      />
    </svg>
  );
};

export default ArrowLeft;
